import { DateFormatter } from '@repo/toolkit/date'
import { z, ZodType } from 'zod'

import {
  HostCommentInput,
  HostCommentRequest
} from '../../../../../lib/types/models/host-comment/host-comment-input'
import {
  HostFamilyLecComment,
  HostFamilyLecCommentGuest
} from '../../../../../lib/types/models/host-family-lec-comment/host-family-lec-comment'
import {
  HostFamilyLecCommentInput,
  HostFamilyLecCommentRequest
} from '../../../../../lib/types/models/host-family-lec-comment/host-family-lec-input'
import { HostFamilyOlComment } from '../../../../../lib/types/models/host-family-ol-comment/host-family-ol-comment'
import { HostFamilyOlCommentInput } from '../../../../../lib/types/models/host-family-ol-comment/host-family-ol-comment-input'
import { createStringSchema } from '../../../../../lib/utils/validations/string-validation'

export const HOST_FAMILY_LEC_COMMENT_SCHEMA: ZodType<
  Omit<HostFamilyLecCommentInput, 'updatedAt'>
> = z.object({
  comment: createStringSchema('Commentaire'),
  sharedToOl: z.boolean({ required_error: "Le commentaire doit être partagé à l'OL ou non" }),
  isVisibleForTheYear: z.boolean({
    required_error: "Le commentaire doit être visible pour l'année ou non"
  }),
  guests: z.array(z.string())
})

export const HOST_FAMILY_OL_COMMENT_SCHEMA: ZodType<Omit<HostFamilyOlCommentInput, 'updatedAt'>> =
  z.object({
    comment: createStringSchema('Comment')
  })

export const mapHostCommentInputToRequest = (data: HostCommentInput): HostCommentRequest => {
  const { createdAt: _createdAt, ...rest } = data
  return rest
}

export const getHostFamilyLecCommentGuestKey = (guest: HostFamilyLecCommentGuest) =>
  `${guest.type}-${guest.id}`

export const mapHostFamilyLecCommentToInput = (
  data: HostFamilyLecComment
): HostFamilyLecCommentInput => {
  return {
    comment: data.comment,
    sharedToOl: data.sharedToOl,
    isVisibleForTheYear: data.isVisibleForTheYear,
    updatedAt: data.updatedAt,
    guests: data.guests.map(getHostFamilyLecCommentGuestKey)
  }
}

/** `NOM Prénom (encadrant) : du dd/mm/yyyy au dd/mm/yyyy` */
export const formatHostFamilyLecCommentGuest = (guest: HostFamilyLecCommentGuest) => {
  const name = [guest.lastName?.toUpperCase(), guest.firstName].filter(Boolean).join(' ')
  const role = guest.type === 'AFFECTED_STAFF' ? ' (encadrant)' : ''
  const dates =
    guest.startDate && guest.endDate
      ? ` : du ${DateFormatter.DDMMYYYY(guest.startDate)} au ${DateFormatter.DDMMYYYY(guest.endDate)}`
      : ''
  return `${name}${role}${dates}`
}

export const mapHostFamilyLecCommentInputToRequest = ({
  updatedAt: _updatedAt,
  guests,
  ...data
}: HostFamilyLecCommentInput): HostFamilyLecCommentRequest => {
  const idsOf = (type: HostFamilyLecCommentGuest['type']) =>
    guests.filter((key) => key.startsWith(`${type}-`)).map((key) => Number(key.split('-')[1]))

  return {
    ...data,
    enrollmentCenterIds: idsOf('ENROLLMENT_CENTER'),
    affectedStaffIds: idsOf('AFFECTED_STAFF'),
    otoIndividualPropositionIds: idsOf('OTO_INDIVIDUAL_PROPOSITION')
  }
}

export const mapHostFamilyOlCommentToInput = (
  data: HostFamilyOlComment
): HostFamilyOlCommentInput => {
  return {
    comment: data.comment,
    updatedAt: data.updatedAt
  }
}
